var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCoins = function SvgCoins(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 50 50"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "ar",
    cx: -12.16,
    cy: -17.13,
    r: 20.602,
    gradientTransform: "translate(32.6 37.545)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "br",
    cx: 72.197,
    cy: 72.885,
    r: 13.92,
    gradientTransform: "translate(-37.606 -43.271) scale(1.006)",
    xlinkHref: "#ar"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cr",
    x1: 9.502,
    y1: 3.584,
    x2: 28.498,
    y2: 36.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.637,
    stopColor: "#c7c7c7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dr",
    x1: 9.726,
    y1: -0.029,
    x2: 24.361,
    y2: 31.633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9d9d9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.379,
    stopColor: "#fcfcfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824,
    stopColor: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "#9d9d9d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "er",
    x1: 19.514,
    y1: 23.842,
    x2: 16.548,
    y2: 1.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c6c6c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#909090"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fr",
    x1: 11.726,
    y1: 5.516,
    x2: 21.937,
    y2: 29.263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9d9d9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.379,
    stopColor: "#fcfcfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    stopColor: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "#acacac"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gr",
    x1: 24.561,
    y1: 36.542,
    x2: 21.174,
    y2: 25.648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.216,
    stopColor: "#fff",
    stopOpacity: 0.763
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604,
    stopColor: "#fff",
    stopOpacity: 0.356
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hr",
    x1: 27.187,
    y1: 19.761,
    x2: 43.145,
    y2: 38.651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff4ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.637,
    stopColor: "#e2bd43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ir",
    x1: 25.061,
    y1: 19.148,
    x2: 45.644,
    y2: 39.573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.037,
    stopColor: "#e5bb48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#fcee81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ce900e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jr",
    x1: 34.711,
    y1: 37.747,
    x2: 34.538,
    y2: 18.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.037,
    stopColor: "#e5bb48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c2954a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kr",
    x1: 37.55,
    y1: 39.929,
    x2: 36.11,
    y2: 33.013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9e879"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199,
    stopColor: "#f3df76",
    stopOpacity: 0.781
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.596,
    stopColor: "#e8cf71",
    stopOpacity: 0.365
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    stopColor: "#e2c56d",
    stopOpacity: 0.102
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dfc16c",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "lr",
    cx: 8458.778,
    cy: 19531.74,
    r: 8.96,
    gradientTransform: "matrix(-.71 .706 -.71 -.706 19886.523 7831.075)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe6ff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "mr",
    "data-name": "Cashback",
    viewBox: "0 0 49.003 44.03"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20.5,
    r: 20.5,
    opacity: 0.46,
    fill: "url(#ar)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.003,
    cy: 30.03,
    r: 14,
    opacity: 0.46,
    fill: "url(#br)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.823,
    cy: 15.265,
    fill: "#0049ff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "<\\u0421\\u043E\\u0441\\u0442\\u0430\\u0432\\u043D\\u043E\\u0439 \\u043A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    d: "M19 1.035a19 19 0 1 0 19 19 19.022 19.022 0 0 0-19-19z",
    fill: "url(#cr)"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    cx: 19,
    cy: 20.035,
    r: 17.1,
    fill: "url(#dr)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    d: "M2.677 20.812a16.706 16.706 0 0 1 33.41-.259c.005-.172.013-.344.013-.518A17.1 17.1 0 1 0 9.387 34.177a16.668 16.668 0 0 1-6.71-13.365z",
    fill: "url(#er)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "<\\u0421\\u043E\\u0441\\u0442\\u0430\\u0432\\u043D\\u043E\\u0439 \\u043A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    d: "M18.889 21.935c2.859 0 6.706-.4 6.706-4.75 0-4.512-2.891-5.665-5.783-5.665-2.355 0-3.408-.079-4.833 0v8.928h-4.75v1.9h4.75v1.9h-4.75v1.9h4.75V30.9h1.9v-4.75h6.65v-1.9h-6.65v-2.315c.949.047 1.135 0 2.01 0zm-2.011-8.515c.95-.04.87 0 2.011 0 2.882 0 4.331 1.24 4.331 3.417 0 2.792-1.328 3.611-4.481 3.611h-1.861z",
    fill: "#666",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "<\\u0421\\u043E\\u0441\\u0442\\u0430\\u0432\\u043D\\u043E\\u0439 \\u043A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    d: "M17.088 20.312c2.859 0 6.755-.4 6.755-4.75 0-4.512-2.966-5.665-5.858-5.665-2.355 0-3.958-.079-4.908 0v8.651h-2.85V21.4h2.85v.95h-2.85v2.85h2.85v5.7h1.9v-6.65h6.65v-1.9h-6.65v-2.038c.951.047 1.236 0 2.111 0zm-2.11-7.565c.95-.04.969 0 2.11 0 2.882 0 4.38 1.1 4.38 3.279 0 2.792-1.279 3.472-4.431 3.472h-2.059z",
    fill: "#666",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "<\\u0421\\u043E\\u0441\\u0442\\u0430\\u0432\\u043D\\u043E\\u0439 \\u043A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    d: "M17.939 20.985c2.859 0 6.706-.4 6.706-4.75 0-4.512-2.891-5.665-5.783-5.665-2.355 0-3.408-.079-4.833 0v8.93h-2.85v1.9h2.85v1.9h-2.85v1.9h2.85v4.75h1.9V25.2h6.65v-1.9h-6.65v-2.315c.949.047 1.135 0 2.01 0zm-2.011-8.515c.95-.04.87 0 2.011 0 2.882 0 4.331 1.24 4.331 3.417 0 2.792-1.328 3.611-4.481 3.611h-1.861z",
    fill: "url(#fr)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    d: "M35.117 15.112A12.773 12.773 0 0 1 34.825 17 15.991 15.991 0 0 1 6.478 30.183a23.86 23.86 0 0 1-1.213-.3 16.8 16.8 0 0 0 29.852-14.771z",
    fill: "url(#gr)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "<\\u0413\\u0440\\u0443\\u043F\\u043F\\u0430>"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "<\\u0421\\u043E\\u0441\\u0442\\u0430\\u0432\\u043D\\u043E\\u0439 \\u043A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    d: "M35 16.014a13 13 0 1 0 13 13 13.015 13.015 0 0 0-13-13z",
    fill: "url(#hr)"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    cx: 35.003,
    cy: 29.014,
    r: 11.616,
    fill: "url(#ir)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    d: "M24.368 29.625a11.263 11.263 0 0 1 21.475-4.757 11.61 11.61 0 1 0-14.682 15.1 11.269 11.269 0 0 1-6.793-10.343z",
    opacity: 0.7,
    fill: "url(#jr)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    d: "M45.894 29.652a10.906 10.906 0 0 1-19.155 6.491 14.8 14.8 0 0 1-1.661-1.119 11.607 11.607 0 0 0 21.541-6.011c0-.233-.021-.46-.035-.69a20.3 20.3 0 0 1-.69 1.329z",
    fill: "url(#kr)"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    d: "M44.413 34.109c-.145.191-1.283.561-1.444.739-.649.716-.794.9-.958 1.046-.971.874-3.287.862-4.583 1.024a3.99 3.99 0 0 1-4.228-2.834 4.756 4.756 0 0 1 .641-4 2.275 2.275 0 0 1 1.319-.867c.674.027.461 1.547.162 1.294 2.238.3 2.182-2.016 1.593-2.717a1.785 1.785 0 0 0-2.344.019 17.007 17.007 0 0 0-1.471 1.82c-.31.413-.712.878-1.225.822.025-.449-.4-.787-.819-.958a3.225 3.225 0 0 0-3.426.6 2.691 2.691 0 0 0-.354 3.366 1.793 1.793 0 0 0 1.453.8 1.193 1.193 0 0 0 1.16-1.054.612.612 0 0 0-.081-.353.559.559 0 0 0-.6-.2 1.035 1.035 0 0 0-.54.4c-.086-.428-.215-1.282.107-1.577s1.023-.761 1.442-.638c.5.148.931 1.335 1.137 1.817a8.876 8.876 0 0 1 .4 1.519 5.006 5.006 0 0 0 1.76 2.575 6.129 6.129 0 0 0 3.986 1.343 12.911 12.911 0 0 1-3.072.691c-.742.034-3.081-.2-3.557-.769a3.052 3.052 0 0 0 1.944 1.583 11.015 11.015 0 0 0 2.556.075c4.229.231 7.55-2.784 9.042-5.566z",
    fill: "#c69017",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    d: "M32.088 29.443c.315-.261 2.02-1.789 1.856-2.216-.3-.773-1.536-2.441-1.833-3.214-1.183.348-2.919 2.378-2.839 3.608.083 1.27 2.209 1.132 2.816 1.822zM45.7 27.544c.242 2.116-1.9 1.7-2.159 1.593s-.986-1.3-1.759-.5c-.582.6.526 1.563.828 1.684a15.473 15.473 0 0 1 1.709.226 2.233 2.233 0 0 1-.807 1.408 2.911 2.911 0 0 1-2.179-.05c-.365-.232-.573-1.5-1.015-1.916a1.056 1.056 0 0 0-.994-.028c-.5.359-.121 1.844.276 2.34.489.611 1.773 1.072 1.387 1.238-.176.075-.444.863-1.832.347-.224-.083-1.21-.733-1.139-1.238.067-.478.287-1.08-.037-1.3s-1.34.071-1.65.38A2.391 2.391 0 0 0 35.953 34c.427 1.117 1.258 1.364 2.207 1.627a6.91 6.91 0 0 0 3.562-.44c.213-.064 1.755-1.358 2.485-1.436 1.008-.109 2.62-4.668 1.493-6.207z",
    fill: "#c69017",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    fill: "url(#lr)",
    d: "M32.668 25.999l-4.972-6.18 5.127-6.333-6.525 4.943-6.914-5.639 5.826 7.029-4.505 5.716 5.748-4.48 6.215 4.944z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2"
  }, /*#__PURE__*/React.createElement("use", {
    "data-name": "Cashback",
    width: 49.003,
    height: 44.03,
    transform: "translate(.5 4.5)",
    xlinkHref: "#mr"
  }))));
};
export default SvgCoins;